import { getInvoice } from 'client/api/invoice'
import { fetchTinkLink } from 'client/api/tink'
import { CompanyInterface } from 'client/Interfaces/CompanyInterface'
import { InvoiceInterface } from 'client/Interfaces/Invoice/InvoiceInterface'
import { PaymentMeanInterface } from 'client/Interfaces/Settings/PaymentMeanInterface'
import { StateInterface } from 'client/Interfaces/StateInterface'
import { l } from 'client/Other/Translation'

const formatRecipientName = (recipient: string, company: CompanyInterface): string => {
  let displayName = ''
  if (recipient) {
    displayName = recipient
  } else {
    const { firstName, lastName } = company
    const contactName = firstName || (lastName && firstName.concat(' ', lastName))
    if (contactName) {
      // eslint-disable-next-line no-nested-ternary
      displayName = contactName.length > 30 ? (!lastName ? firstName : firstName[0].concat(' ', lastName)) : contactName
    } else {
      displayName = l('TinkPayment.recipientName.default')
    }
  }
  return String(
    displayName
      .normalize('NFD')
      .replace(/\p{Diacritic}/gu, '')
      .replace(/[^a-zA-Z0-9 ]/g, '')
      .replace(/ +(?= )/g, '')
      .slice(0, 30),
  )
}

export const getDefaultIBAN = (paymentMethods: PaymentMeanInterface[]) => {
  const IBANPaymentMethod = paymentMethods.find((item) => item.type === 'IBAN')
  return IBANPaymentMethod?.fields?.iban?.length ? IBANPaymentMethod.fields.iban : null
}

export const getTinkLink = async (state: StateInterface, tinkPaymentEnabled: boolean, invoiceId: number) => {
  const invoice = (await getInvoice(invoiceId)) as InvoiceInterface
  const { company } = state
  const {
    invoicedocument: { receiver, invoicer, summary, paymentMeans, fields },
  } = invoice
  const { invoiceNumber, referenceNumber } = fields
  const referenceNumberValue = referenceNumber.value ? ` ${referenceNumber.value}` : ''
  const accountNumber = getDefaultIBAN(paymentMeans)
  const locale = `${receiver.language}_${receiver.address.country}`
  const recipientName = formatRecipientName(invoicer.tradeName.name, company)

  if (!invoice || !accountNumber || !tinkPaymentEnabled) {
    return null
  }

  const payload = {
    accountNumber,
    accountType: 'IBAN',
    amount: summary.grossTotal,
    currency: summary.currency,
    market: receiver.address.country,
    recipientName,
    sourceMessage: `{"invoiceId":${invoiceId},"companyId": ${company.id}}`,
    remittanceInformationType: 'UNSTRUCTURED',
    remittanceInformationValue: `${invoiceNumber.value}${referenceNumberValue}`,
    paymentScheme: 'SEPA_CREDIT_TRANSFER',
    locale,
  }

  try {
    const tinkLinkResponse = await fetchTinkLink(payload)
    return tinkLinkResponse.tinkLink
  } catch (e) {
    return null
  }
}
